import type { PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const radioV3Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Radio element to v3 by setting an explicit tile corner radius, checkmark size and card paddings',
  run: (props: PartialPropsOf<'radio'>): void => {
    const radio = props?.style?.radio;
    if (radio) {
      if (!radio.tileRadius) {
        radio.tileRadius = props.content?.mode === 'chip' ? '25px' : '4px';
      }
      if (!radio.checkmarkSize) {
        radio.checkmarkSize = props.content?.mode === 'card' ? '16px' : '24px';
      }
    }

    const card = props?.style?.card;
    if (card?.subheading && !card.subheading.spaceAbove) {
      card.subheading.spaceAbove = '5px';
    }
    if (card?.description && !card.description.spaceAbove) {
      card.description.spaceAbove = '16px';
    }
    if (card?.customField && !card.customField.spaceAbove) {
      card.customField.spaceAbove = '16px';
    }
  },
};
